import type { FC } from 'react';
import { Icon, Skeleton, Table } from '@ui';
import { useTranslation } from 'react-i18next';
import { clientOnly } from 'vike-react/clientOnly';
import { useRegionAtc } from '@/queries/useRegionAtc';

const AtcLogonTime = clientOnly(() => import('./AtcLogonTime').then(r => r.AtcLogonTime));

export const ActiveAtcTable: FC = () => {
    const { data: atc } = useRegionAtc();
    const { t } = useTranslation();

    return (
        <Table
            variant="secondary"
            block
            columns={[
                { title: t('ATC_Table_Callsign'), dataProperty: 'callsign' },
                {
                    title: t('ATC_Table_Online'),
                    dataProperty: 'logon_time',
                    render: (value: string | number) => <AtcLogonTime logonTime={value} fallback={<Skeleton width={64} height={14} />} />
                },
                { title: t('ATC_Table_Freq'), dataProperty: 'frequency' }
            ]}
            data={atc}
            rowKey={e => `${e.cid}${e.callsign}`}
            empty={{
                icon: <Icon.CalendarClock size={48} color="textTertiary" />,
                title: t('ATC_Table_Empty')
            }}
        />
    );
};
